import axiosInstance from '../../../src/helpers/axiosConfig';
import apiClient from '../../helpers/axiosHelper';
import config from '../../config';

export const getTrainingData = async () =>{
    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

    try {
        const response = await axiosInstance.get(`${baseUrl}Enrollment/EnrollmentType?EnrollmentType=TPATraining`)
  
        //console.log('getTrainingData: ', response)
        return response
      } catch (error) {
        // console.error('Register catch Error:', error)
        throw error
      }
}


export const methodSubscribe = async (data) => {
  const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

  try {
    
    const response = await apiClient.post(`${baseUrl}Enrollment/Subscribe` ,data,
      {
        headers: { 'Content-Type': 'application/json' },

      })

      //console.log('response de subscribe: ', response)


      if(response){


        return response
      }

  } catch (error) {
    //console.log('error: ',error)
  }
}


export const subscriptionStatus = async () => {
  const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL
  try {
    const response = await apiClient.get(`${baseUrl}Member/UserInfo`)

    if(response){
      //console.log('subscriptionStatus', response)
      return response
    }
  } catch (error) {
    
  }
}